import CloudQuotaBackupSettings from './Quota';

export default CloudQuotaBackupSettings;
